export default "__VITE_ASSET__BhCs5RbM__"